import { render, staticRenderFns } from "./FormRow.vue?vue&type=template&id=f72049d4&scoped=true&"
import script from "./FormRow.vue?vue&type=script&lang=js&"
export * from "./FormRow.vue?vue&type=script&lang=js&"
import style0 from "./FormRow.vue?vue&type=style&index=0&id=f72049d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f72049d4",
  null
  
)

export default component.exports